export enum MeasurementType {
    cm = "cm"
}